import * as React from 'react';

import ListProductionGroups from '../../components/list/production-groups';
import ListPackages from '../../components/list/packages';

import { ListContainerProps } from '../../components/list/container';

const ListPerformanceGroupsContainerView: React.StatelessComponent<ListContainerProps> = props => {
    return (
        <>
            {
                props.isFixed ?
                    <ListPackages />
                    :
                    <ListProductionGroups />

            }
        </>
    );
}

export default ListPerformanceGroupsContainerView;